import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

function Contact() {
    const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_2qy0vx6', 'template_4rx4z8q', form.current, {
        publicKey: 'sGEsEXZWClVPbEFjk',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          e.target.reset();
          alert('Email sent successfully.');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };
    return (
        <section className='contact'>
            <div>
                <h1 className="animate__animated animate__slideInDown">Co<span className="underline">ntact</span></h1>
                <p className="animate__animated animate__fadeIn animate__delay-1s">Do you have any questions or just want to drop by and say hi? Feel free to contact me, and I'll be happy to reply.</p>
                <form className="animate__animated animate__fadeIn animate__delay-1s" ref={form} onSubmit={sendEmail}>
                <label htmlFor="user_name">Name</label>
                <input type="text" name="user_name" placeholder='Your name' required />
                <label htmlFor="user_email">Email</label>
                <input type="email" name="user_email" placeholder='example@gmail.com' required />
                <label htmlFor="message">Message</label>
                <textarea name="message" placeholder='Your message...' required />
                <button type="submit" value="Send">Submit</button>
            </form>
            </div>
    </section>
    );
}

export default Contact;